var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12, 10) scale(0.035)",
    fill: "#033476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 339l-28.3-28.3-71.9 71.9-72-71.9-28.3 28.3 72 71.9-72 72 28.3 28.2 72-71.9 71.9 71.9 28.3-28.2-72-72z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M403.8 148.1c0 81.5-66.4 147.9-147.9 147.9-119.1 0-215.9 96.8-215.9 215.9h-40c0-68.4 26.6-132.6 74.9-181 27.9-27.8 61.1-48.5 97.3-60.9-38.8-26.7-64.3-71.4-64.3-121.9 0-81.6 66.4-148 148-148 81.5 0 147.9 66.4 147.9 148zm-40 0c0-59.6-48.4-108-107.9-108-59.6 0-108 48.4-108 108 0 59.5 48.4 107.9 108 107.9 59.5 0 107.9-48.4 107.9-107.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteuser);
export default __webpack_public_path__ + "static/media/Deleteuser.8e1fc6d37630389a6dc354167d9108b5.svg";
export { ForwardRef as ReactComponent };